module.exports = __webpack_public_path__ + "img/5.38736c0a.png";